module.exports = __webpack_public_path__ + "img/calendar2-range.1e442b09.svg";